/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Periods, Entities } from 'cio/utils/metrics/common';
import EnvironmentModel from 'cio/models/environment';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import { inject as service } from '@ember/service';
import ApiService from 'cio/services/api';
import moment from 'moment-timezone';
import { sort } from '@ember/object/computed';
import MetricsService from 'cio/services/metrics';
import { TrackedLinkMetric, TrackedLinkMetricStat } from 'cio/utils/metrics/models/tracked-link-metric';
import AnalyticsService from 'cio/services/analytics';
import { TimeRange } from 'cio/utils/time';

interface DashboardPageLinksCardArgs {
  environmentModel: EnvironmentModel;
  timeRange: TimeRange;
  resolution: Periods;
  isLoading: boolean;
  isUpdating: boolean;
}

export default class DashboardPageLinksCard extends Component<DashboardPageLinksCardArgs> {
  @service analytics!: AnalyticsService;
  @service api!: ApiService;
  @service('metrics') metricsService!: MetricsService;

  @tracked trackedLinkMetric: TrackedLinkMetric | null = null;

  linkMetricsSorting = ['periodTotalClicked:desc'];
  @sort('trackedLinkMetric.stats', 'linkMetricsSorting') sortedLinkMetrics!: TrackedLinkMetricStat[];

  fetchLinks = task({ restartable: true }, async () => {
    this.trackedLinkMetric = await this.metricsService.fetchTrackedLinkMetric(
      Entities.ENVIRONMENT,
      this.args.environmentModel.id,
      this.args.resolution === Periods.MONTHS ? Periods.MONTHS : Periods.CUSTOM,
      this.utcTimeRange,
      'all',
      {
        environmentId: this.args.environmentModel.id,
        version: 2,
      },
    );
  });

  get utcTimeRange() {
    return {
      start: moment.tz(`${this.args.timeRange.start?.format('YYYY-MM-DD')} 00:00:00`, 'Etc/UTC'),
      end: moment.tz(`${this.args.timeRange.end?.format('YYYY-MM-DD')} 00:00:00`, 'Etc/UTC'),
    };
  }
}
